<div class="jumbotron text-center" style="font-size: 130%; padding: 50px;">
    <h2 id="noAccess">
        <span class="{{severity}}"></span>
            {{title}}
    </h2>
    <p>{{instructions1}}.</p>
    <p>{{instructions2}}</p>
    <p *ngIf="title === 'Acceso Denegado'" style="font-size: 80%; color: #666;">
        Redirigiendo en {{countdown}} segundo{{countdown !== 1 ? 's' : ''}}...
    </p>
    <p *ngIf="buttonLabel">
        <p-button type="button" [label]="buttonLabel" styleClass="ui-button-success" (click)="goToUrl()"></p-button>
    </p>
    <br>
</div>